import Button from '@components/Button';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

import useInquiryForm from './hooks/useInquiryForm';

type UseInquiryForm = ReturnType<typeof useInquiryForm>;

interface Props {
    values: Pick<UseInquiryForm, 'reset' | 'handleCreateInquiry' | 'privacy' | 'setPrivacy'>;
}

function InquiryFormFooter({ values }:Props) {
    const {
        reset, handleCreateInquiry, privacy, setPrivacy,
    } = values;
    const { t } = useTranslation('inquiry');
    const termCategory = useTermCategories('INQUIRY')?.[0];
    return (
        <Container spacing={4} fullWidth>
            <AgreementRow fullWidth spacing={2}>
                <Checkbox isChecked={privacy}
                    onClick={() => setPrivacy(!privacy)} >
                    {t('form.privacyAgreement')}
                </Checkbox>
                {termCategory && (
                    <Link activityName='TermDetailActivity'
                        activityParams={{ termCategoryId: termCategory.id }}>
                        <TermText fontWeight='bold'>
                            {t('form.viewTerm')}
                        </TermText>
                    </Link>
                )}
            </AgreementRow>
            <Row spacing={2} fullWidth>
                <ActionButton variant='tone'
                    onClick={reset}
                    type='button'>{t('form.reset')}</ActionButton>
                <ActionButton onClick={handleCreateInquiry} >
                    {t('form.submit')}
                </ActionButton>
            </Row>
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-background-pure);
    border-top: 1px solid var(--color-border-default);
    bottom: 0;
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
    position: sticky;
`;

const AgreementRow = styled(Row)`
    padding: var(--spacing-2) 0;

    > [aria-label='checkbox'] {
        flex: 1;
        min-width: 0;
        padding-right: 0;
    }
`;

const TermText = styled(Text)`
    color: #84665E;
    white-space: nowrap;
`;

const ActionButton = styled(Button)`
    flex: 1;
    padding: 0;
`;

export default InquiryFormFooter;
